var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.958,
    height: 20,
    viewBox: "0 0 14.958 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    transform: "translate(-99.773 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_15_",
    transform: "translate(99.773 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M102.377,0h6.687l5.667,5.907V17.4a2.6,2.6,0,0,1-2.6,2.6h-9.755a2.6,2.6,0,0,1-2.6-2.6V2.6a2.6,2.6,0,0,1,2.6-2.6Z",
    transform: "translate(-99.773 0)",
    fill: "#15345a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654",
    transform: "translate(2.894 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M467.219,0V5.862h5.672Z",
    transform: "translate(-460.827)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M214.278,449.612v-3.653h1.554a1.288,1.288,0,0,1,.92.32,1.219,1.219,0,0,1,0,1.7,1.288,1.288,0,0,1-.92.32h-.62v1.314Zm.935-2.109h.515a.461.461,0,0,0,.325-.1.386.386,0,0,0,0-.55.46.46,0,0,0-.325-.1h-.515Zm2.269,2.109v-3.653h1.294a2.26,2.26,0,0,1,.72.11,1.934,1.934,0,0,1,.61.325,1.435,1.435,0,0,1,.43.57,2.259,2.259,0,0,1,0,1.644,1.434,1.434,0,0,1-.43.57,1.935,1.935,0,0,1-.61.325,2.261,2.261,0,0,1-.72.11Zm.915-.795h.27a1.5,1.5,0,0,0,.4-.05,1.214,1.214,0,0,0,.345-.165.741.741,0,0,0,.25-.32,1.419,1.419,0,0,0,0-.995.741.741,0,0,0-.25-.32,1.214,1.214,0,0,0-.345-.165,1.5,1.5,0,0,0-.4-.05h-.27Zm2.764.795v-3.653h2.6v.795h-1.664v.585h1.329v.79h-1.329v1.484Z",
    transform: "translate(-214.278 -434.69)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfViewIcon);
export default __webpack_public_path__ + "static/media/pdfViewIcon.8c8a1ccae36a988c14aff9c677e07c86.svg";
export { ForwardRef as ReactComponent };